import React, { useState, useEffect } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Newpagination from '../../Components/Pagination/pagination.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import DatePicker from '../../Components/DatePicker/date-picker.tsx';
import formatDate from '../../Utils/DateFormat/date-format.tsx';
import { getWarehouseCompanyMapping, getVehicle } from './action.ts';
import { getOrders, addSingleOrder, editOrders, getTrips, editTripRemarks } from './action.ts';
import OrderDetailsModal from './order-details-modal.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import { SelectChangeEvent } from '@mui/material/Select';
import AssignVehicleModal from './assign-vehicle-modal.tsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import StatusFilterTabs from '../../Components/Tab/tab.tsx';
import SingleOrderModal from './single-order-modal.tsx';
import BulkOrderModal from './bulk-order-modal.tsx';
import UploadPreviewModal from './upload-preview-modal.tsx';
import { Box, Typography, Button, IconButton, Menu, MenuItem, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UploadIcon from '@mui/icons-material/Upload';

interface OrderDetailsModalProps {
    open: boolean;
    onClose: () => void;
    orderId: string;
    orders: any;
}
interface Item {
    id: string;
    skuId: string;
    item: string;
    description: string;
    rate: string;
    quantity: string;
    total: string;
    hsnCode?: string;
    igst?: string;
    cgst?: string;
    sgst?: string;
    discount?: string;
}
interface FormData {
    orderId: string;
    date: string;
    name: string;
    pincode: string;
    address: string;
    cityState: string;
    mobile: string;
    email: string;
    latitude: string;
    longitude: string;
    delivery_type?: string;
    customerId?: string;
    isNewAddress?: boolean;
}

const OrdersPage = () => {
    const [activeTab, setActiveTab] = useState<string>('Order Details');
    const [page, setPage] = useState<number>(0);
    const [orders, setOrders] = useState<any[]>([]);
    const [trips, setTrips] = useState<any[]>([]);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [totalTripRecords, setTotalTripRecords] = useState<number>(0);
    const [warehouseOptions, setWarehouseOptions] = useState<{ id: string, label: string }[]>([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string, name: string } | null>(null);
    const [pageSize, setPageSize] = useState<number>(10);
    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [selectedTripIds, setSelectedTripIds] = useState<string[]>([]);
    const [assignModalOpen, setAssignModalOpen] = useState(false);
    const [vehicleOptions, setVehicleOptions] = useState<{ id: string, label: string }[]>([]);
    const [selectedVehicle, setSelectedVehicle] = useState<{ id: string, name: string } | null>(null);
    const [orderDetailsModalOpen, setOrderDetailsModalOpen] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState('');
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [uploadAnchorEl, setUploadAnchorEl] = useState<null | HTMLElement>(null);
    const [singleOrderModalOpen, setSingleOrderModalOpen] = useState(false);
    const [bulkOrdersModalOpen, setBulkOrdersModalOpen] = useState(false);
    const [uploadPreviewModal, setUploadPreviewModal] = useState(false);
    const [selectedWarehouseName, setSelectedWarehouseName] = useState<string | null>(null);
    const [tableData, setTableData] = useState<any[]>([]);
    const [tableColumns, setTableColumns] = useState<any[]>([]);
    const [items, setItems] = useState<Item[]>([]);
    const [refreshTrigger, setRefreshTrigger] = React.useState(false);
    const [step, setStep] = useState<'order' | 'item'>('order');
    const [deliveryType, setDeliveryType] = useState<string>('delivery');
    
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [selectedFromDate, setSelectedFromDate] = useState<string>(getTodayDate());
    const [selectedToDate, setSelectedToDate] = useState<string>(getTodayDate());
    const [formData, setFormData] = useState<FormData>({
        orderId: '',
        date: new Date().toISOString().split('T')[0],
        name: '',
        pincode: '',
        address: '',
        cityState: '',
        mobile: '',
        email: '',
        latitude: '',
        longitude: '',
        customerId: '',
        isNewAddress: true
    });
    const [currentItem, setCurrentItem] = useState<Omit<Item, 'id'>>({
        skuId: '',
        item: '',
        description: '',
        rate: '',
        quantity: '',
        total: '0.00',
    });
    const [showGst, setShowGst] = useState(false);
    const [weight, setWeight] = useState('');
    const [crates, setCrates] = useState('');
    const [cod, setCod] = useState('');
    const [grandTotal, setGrandTotal] = useState('');
    const [logisticsCost, setLogisticsCost] = useState('0');
    const [dimensions, setDimensions] = useState({
        length: '',
        breadth: '',
        height: ''
    });
    const minDate = new Date('2023-01-01');
    const maxDate = new Date();
    const showEntries = [
        { id: '10', label: '10' },
        { id: '20', label: '20' },
        { id: '50', label: '50' },
        { id: '100', label: '100' },
    ];
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const userRole = userDetailsFromStorage?.role?.toLowerCase();
    const companiesId = userDetailsFromStorage?.companies_id || ''
    
    // CHANGE 2: Handler accepts string directly
    const handleTabChange = (newTab: string) => {
        setActiveTab(newTab);
        setPage(0);
    }
    
    const refreshData = () => {
        setRefreshTrigger(prev => !prev);
    };

    // ... (Keep resetAllOrderFields, handleCreateSingleOrder logic as is) ...
    const resetAllOrderFields = () => {
        setItems([]);
        setCurrentItem({
            skuId: '',
            item: '',
            description: '',
            rate: '',
            quantity: '',
            total: '0.00',
            hsnCode: '',
            igst: '',
            cgst: '',
            sgst: '',
            discount: ''
        });
        setShowGst(false);
        setWeight('');
        setCrates('');
        setCod('No');
        setDeliveryType('')
        setLogisticsCost('0');
        setGrandTotal('');
        setDimensions({
            length: '',
            breadth: '',
            height: ''
        });
        setStep('order')
        setFormData({
            orderId: '',
            date: new Date().toISOString().split('T')[0],
            name: '',
            pincode: '',
            address: '',
            cityState: '',
            mobile: '',
            email: '',
            latitude: '',
            longitude: '',
            customerId: '',
            isNewAddress: true
        });
    };

    const handleCreateSingleOrder = (orderData: any) => {
        const hasItemsInList = items.length > 0;
        const hasCurrentItem = currentItem.item && currentItem.description && currentItem.rate && currentItem.quantity;

        if (!hasItemsInList && !hasCurrentItem) {
            toast.error('No items found in the order');
            return;
        }
        const calculateItemTotal = (item: Omit<Item, 'id'>) => {
            const rateValue = parseFloat(item.rate || '0');
            const quantityValue = parseFloat(item.quantity || '0');
            const igstValue = parseFloat(item.igst || '0');
            const cgstValue = parseFloat(item.cgst || '0');
            const sgstValue = parseFloat(item.sgst || '0');
            const discountValue = parseFloat(item.discount || '0');
            const subTotal = rateValue * quantityValue;
            const discountAmount = subTotal * discountValue / 100;
            const subTotalWithDiscount = subTotal - discountAmount;
            const totalGst = (igstValue + cgstValue + sgstValue) / 100 * subTotalWithDiscount;
            const total = subTotalWithDiscount + totalGst;
            return total.toFixed(2);
        };
        let allItems = [...items];
        if (hasCurrentItem) {
            allItems.push({
                ...currentItem,
                id: Date.now().toString(),
                total: calculateItemTotal(currentItem)
            });
        }
        const {
            orderId,
            date: order_creation_date,
            name: to_name,
            address: to_street_lines,
            cityState,
            pincode: to_pin,
            mobile: to_phone,
            email: to_email,
            latitude,
            longitude,
            customerId,
            isNewAddress,
            force_new_Customer
        } = orderData;
        const [to_city, to_state] = cityState.split(',').map((item:any) => item.trim());
        const firstItem = allItems[0];
        const tax_amount = showGst ?
            (parseFloat(firstItem.igst || '0')) +
            (parseFloat(firstItem.cgst || '0')) +
            (parseFloat(firstItem.sgst || '0')) : 0;

        let additionalItems = {};
        if (allItems.length > 1) {
            additionalItems = allItems.slice(1).reduce((acc: any, item: any, index: number) => {
                const itemKey = `item${index + 1}`;
                acc[itemKey] = {
                    item_name: item.item,
                    item_description: item.description,
                    price: item.rate,
                    quantity: item.quantity,
                    cgst_amount: item.cgst ? parseFloat(item.cgst) : null,
                    sgst_amount: item.sgst ? parseFloat(item.sgst) : null,
                    igst_amount: item.igst ? parseFloat(item.igst) : null,
                    discount_amount: item.discount ? parseFloat(item.discount) : null,
                    hsn_code: item.hsnCode || ""
                };
                return acc;
            }, {});
        }

        addSingleOrder(
            firstItem.item,
            firstItem.description,
            cod,
            to_name,
            '',
            to_street_lines,
            'IN',
            to_pin,
            to_phone,
            to_email,
            orderId,
            firstItem.quantity,
            'PCS',
            deliveryType,
            weight,
            'KG',
            firstItem.rate,
            'IN',
            'INR',
            firstItem.cgst ? parseFloat(firstItem.cgst) : 0,
            firstItem.igst ? parseFloat(firstItem.igst) : 0,
            firstItem.sgst ? parseFloat(firstItem.sgst) : 0,
            firstItem.discount ? parseFloat(firstItem.discount) : 0,
            firstItem.hsnCode || '',
            JSON.stringify(additionalItems),
            firstItem.skuId || '',
            logisticsCost,
            latitude,
            longitude,
            dimensions.length,
            dimensions.breadth,
            dimensions.height,
            to_city,
            to_state,
            order_creation_date,
            grandTotal,
            customerId,
            force_new_Customer || '',
            (response: any) => {
                if (response.status === 200) {
                    toast.success('Order created successfully!');
                    resetAllOrderFields();
                    setSingleOrderModalOpen(false);
                    setRefreshTrigger(prev => !prev);
                }
                else if (response.status === 400 && response.message?.creation_status === "This order id already exists") {
                    toast.error(`Order ID "${orderData.orderId}" already exists. Please use a different Order ID.`);
                }
                else {
                    toast.error("Order Creation Failed")
                }
            },
            (error: any) => {
                if (error.status === 400 && error.message?.creation_status === "This order id already exists") {
                    toast.error(`Order ID "${orderData.orderId}" already exists. Please use a different Order ID.`);
                } else {
                    toast.error(`Failed to create order: ${error.message || 'Unknown error'}`);
                }
            }
        );
    };
    
    const handleAssignVehicle = (warehouseId: string, vehicleId: string) => {
        toast.success(`Vehicle ${vehicleId} assigned to warehouse ${warehouseId} for ${selectedRows.length} orders`);

        setOrders(orders.map(order =>
            selectedRows.includes(order.id)
                ? {
                    ...order,
                    orderStatus: 'Vehicle Assigned',
                    vehicles_id: vehicleId,
                    warehouses_id: warehouseId
                }
                : order
        ));
        setSelectedRows([]);
    }

    useEffect(() => {
        sessionStorage.removeItem('trips_active_tab');
        fetchVehicles();
    }, [selectedWarehouse,]);
    const fetchVehicles = () => {
        getVehicle(
            100,
            0,
            (response: any) => {
                const options = response.message?.vehicles_list.map((vehicle: any) => ({
                    id: vehicle.id,
                    label: vehicle.number_plate,
                }));
                setVehicleOptions(options);
            },
            (errMessage: any) => {
                toast.error(errMessage);
                setVehicleOptions([]);
            },
            1,
            '',

            selectedWarehouse?.name || '',
        );
    };
    const handleVehicleChange = (event: SelectChangeEvent<string>) => {
        const vehicleId = event.target.value;
        const vehicle = vehicleOptions.find(v => v.id === vehicleId);
        const transformedVehicle = vehicle ? { id: vehicle.id, name: vehicle.label } : null;
        setSelectedVehicle(transformedVehicle);
    }

    const handlePageClick = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage - 1);
    };
    const handleWarehouseChange = (event: SelectChangeEvent<string>) => {
        const warehouseId = event.target.value;
        const warehouse = warehouseOptions.find(c => c.id === warehouseId);
        const transformedWarehouse = warehouse ? { id: warehouse.id, name: warehouse.label } : null;
        setSelectedWarehouse(transformedWarehouse);
    }

    const handleRowSelection = (ids: number[]) => {
        const nonCreatedOrders = orders.filter(order =>
            ids.includes(order.id) &&
            order.status?.toLowerCase() !== 'order created' &&
            order.status?.toLowerCase() !== 'created' && order.status?.toLowerCase() !== 'vehicle assigned'
        );

        if (nonCreatedOrders.length > 0) {
            toast.error(`Cannot select orders with status: ${nonCreatedOrders.map(order => order.status).join(', ')}.`);
            return;
        }

        setSelectedRows(ids);
        const tripIds = orders
            .filter(order => ids.includes(order.id))
            .map(order => order.trip_id || '')
            .filter(tripId => tripId !== '');
        setSelectedTripIds(tripIds);

        if (ids.length > 0) {
            const selectedOrder = orders.find(order => order.id === ids[0]);
            if (selectedOrder) {
                setSelectedWarehouseName(selectedOrder.warehouse_name);
            }
        } else {
            setSelectedWarehouseName(null);
        }
    };

    const handleOpenOrderDetails = (orderId: string) => {
        setSelectedOrderId(orderId);
        setOrderDetailsModalOpen(true);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    };

    const handleUpload = () => {
        if (!selectedFile) {
            toast.error('Please select a file to upload');
            return;
        }
        toast.info(`Uploading file: ${selectedFile.name}`);
        setTimeout(() => {
            toast.success('Orders uploaded successfully!');
            setSelectedFile(null);
        }, 2000);
    };

    const handleUploadClick = (event: React.MouseEvent<HTMLElement>) => {
        setUploadAnchorEl(event.currentTarget);
    };

    const handleUploadClose = () => {
        setUploadAnchorEl(null);
    };

    const handleSingleOrderClick = () => {
        handleUploadClose();
        setSingleOrderModalOpen(true);
    };

    const handleBulkOrdersClick = () => {
        handleUploadClose();
        // setBulkOrdersModalOpen(true);
    };

    useEffect(() => {

        getWarehouseCompanyMapping(
            companiesId,
            (response: any) => {
                const options = response.user_warehouses.map((warehouses: any) => ({
                    id: warehouses.warehouse.id,
                    label: warehouses.warehouse.name,
                }));
                setWarehouseOptions(options);
            },
            (errMessage: any) => {
                toast.error(errMessage.message);
            }
        );

        // CHANGE 3: Logic checks for "Order Details" or "Trip Details" string
        if (activeTab === 'Order Details') {
            getOrders(
                pageSize,
                page, '', '', '', '', '', '', '', '', selectedWarehouse?.id,
                (response: any) => {
                    if (response.status === 200) {
                        setOrders(response.message.orders_list);
                        setTotalRecords(response.message.total_count);
                    } else {
                        setOrders([]);
                        setTotalRecords(0);
                    }
                },
                (error: string) => {
                    toast.error(error);
                    setOrders([]);
                    setTotalRecords(0);
                }
            );
        } else if (activeTab === 'Trip Details') {
            getTrips(
                pageSize,
                page,
                selectedFromDate || '',
                selectedToDate || '',
                (response: any) => {
                    if (response.status === 200) {
                        setTrips(response.message.trips_list || []);
                        setTotalTripRecords(response.message.total_count || 0);
                    } else {
                        setTrips([]);
                        setTotalTripRecords(0);
                    }
                },
                (error: string) => {
                    toast.error(error);
                    setTrips([]);
                    setTotalTripRecords(0);
                },
                selectedVehicle?.id ? parseInt(selectedVehicle.id) : undefined,
                selectedWarehouse?.name,
                1,
            );
        }
    }, [page, pageSize, activeTab, selectedFromDate, selectedToDate, selectedVehicle, selectedWarehouse, refreshTrigger]);


    const tripRows = trips.map((trip, index) => ({
        id: trip.id || index,
        slNo: index + 1 + (page * pageSize),
        date: trip.trip_date || 'N/A',
        vehicleNumber: trip.number_plate || 'N/A',
        driver: trip.driver_name || 'N/A',
        warehouse: trip.warehouse_name || '',
        picked_delivered: `${trip.orders_picked}/${trip.orders_delivered}` || 0,
        tripStatus: trip.trip_status || (
            trip.end_time
                ? 'Trip ended'
                : trip.start_time
                    ? 'In progress'
                    : 'Vehicle assigned'
        ),
        remarks: trip.remarks,
        endTime: trip.end_time,
        startTime: trip.start_time,
    }));

    const orderRows = orders.map((order, index) => ({
        id: order.id,
        slNo: index + 1 + (page * pageSize),
        orderId: order.order_id,
        tripId: order.trip_id || '',
        pickUpWarehouse: warehouseOptions.find(w => w.id.toString() === order.warehouses_id?.toString())?.label || 'Unknown',
        orderStatus: order.status || 'pending',
        paymentMode: order.cod ? 'COD' : 'Prepaid',
        paymentType: order.cod ? `₹${order.amount_cash || 0} Cash` : 'N/A',
        amount: order.amount || 0,
        amountUPI: order.amount_upi || 0,
        amountCash: order.amount_cash || 0,
        vehicleNumber: order.vehicle_plate || 'Not assigned',
        driverName: order.driver_name || 'Not assigned',
        toName: order.to_name,
        deliveryLocation: order.customer_address,
        toPincode: order.customer_pincode,
        toPhone: order.customer_phone,
        toEmail: order.customer_email,
        dimensions: `${order.length}x${order.breadth}x${order.height} cm`,
        weight: `${order.package_weight} kg`,
        orderDate: new Date(order.order_created_date).toLocaleDateString('en-GB'),
        lastUpdated: new Date(order.last_updated_date).toLocaleString(),
        remarks: order.remarks || ''
    }));

    const orderColumns: GridColDef[] = [
        { field: 'slNo', headerName: 'Sl.No', width: 60, headerAlign: 'center', align: 'center' },
        {
            field: 'orderDate',
            headerName: 'Date',
            width: 100,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'orderId',
            headerName: 'Order ID',
            width: 130,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Box display="flex" alignItems="center" gap={1}>
                    {params.row.orderId}
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenOrderDetails(params.row.id);
                        }}
                        sx={{ padding: '4px' }}
                    >
                        <AddIcon fontSize="small" color="primary" />
                    </IconButton>
                </Box>
            )
        },
        {
            field: 'vehicleDriver',
            headerName: 'Vehicle/Driver',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Box display="flex" flexDirection="column">
                    <Typography>{params.row.vehicleNumber}</Typography>
                    <Typography variant="caption" color="textSecondary">
                        {params.row.driverName}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'pickUpWarehouse',
            headerName: 'Pick Up Warehouse',
            width: 150,
            headerAlign: 'center',
            align: 'center'
        },
        {
            field: 'deliveryLocation',
            headerName: 'Delivery Location',
            width: 205,
            headerAlign: 'center',
            align: 'center'
        },

        {
            field: 'paymentMode',
            headerName: 'Payment Mode',
            width: 170,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const isCOD = params.row.paymentMode === 'COD';
                const amount = params.row.amount;
                const cashAmount = params.row.amountCash;
                const upiAmount = params.row.amountUPI;

                return (
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography fontWeight="bold">
                            {params.row.paymentMode} - ₹{amount}
                        </Typography>
                        {isCOD && (
                            <Typography variant="caption">
                                Cash - ₹{cashAmount}, UPI - ₹{upiAmount}
                            </Typography>
                        )}
                    </Box>
                );
            }
        },
        {
            field: 'orderStatus',
            headerName: 'Status',
            width: 100,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const status = params.value?.toLowerCase() || '';
                let color = 'black';

                if (status.includes('attempted') || status.includes('reject')) {
                    color = 'red';
                } else if (status.includes('partially')) {
                    color = 'orange';
                } else if (status.includes('delivered')) {
                    color = 'green';
                } else if (status.includes('ofd')) {
                    color = '#004085'
                }
                return (
                    <Typography
                        sx={{
                            color: color,
                            textTransform: 'capitalize',
                        }}
                    >
                        {params.value}
                    </Typography>
                );
            }

        },
        {
            field: 'remarks',
            headerName: 'Remarks',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            editable: true,
            renderCell: (params) => (
                <Box
                    sx={{
                        width: '100%',
                        minHeight: '40px',
                        maxHeight: '100px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '6px',
                        backgroundColor: params.row.remarks ? '#f9f9f9' : '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        '&:hover': {
                            borderColor: '#68E0CF',
                            backgroundColor: '#f5f5f5'
                        }
                    }}
                >
                    <Typography
                        sx={{
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            lineHeight: '1.2',
                            width: '100%',
                            color: params.row.remarks ? 'inherit' : '#999',
                            fontStyle: params.row.remarks ? 'normal' : 'italic'
                        }}
                    >
                        {params.row.remarks || 'Click to add remarks...'}
                    </Typography>
                </Box>
            ),
            renderEditCell: (params) => (
                <Box
                    sx={{
                        width: '100%',
                        padding: '8px',
                    }}
                >
                    <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        value={params.value || ''}
                        onChange={(e) => params.api.setEditCellValue({
                            id: params.id,
                            field: params.field,
                            value: e.target.value
                        })}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                fontSize: '0.875rem',
                                '& textarea': {
                                    whiteSpace: 'pre-wrap',
                                    wordWrap: 'break-word',
                                    lineHeight: '1.5'
                                }
                            }
                        }}
                        autoFocus
                    />
                </Box>
            )
        }
    ];
    const handleTripRemarksEdit = async (params: any) => {
        const { id, field, value } = params;
        editTripRemarks(
            params.id,
            "",
            "",
            "",
            "",
            1,
            params.remarks,
            (response:any) => {
                toast.success(response.message)
            },
            (error:any) => {
                toast.error(error.message)
            }
        );

    };

    const handleOrderRemarksEdit = async (params: any) => {
        const { id, field, value } = params;
        try {
            const originalOrder = orders.find(order => order.id === id);
            if (!originalOrder) return;
            await new Promise<void>((resolve, reject) => {
                editOrders(
                    originalOrder.id,
                    originalOrder.warehouses_id,
                    originalOrder.vehicles_id || null,
                    originalOrder.status,
                    originalOrder.amount_upi || null,
                    originalOrder.amount_cash || null,
                    params.remarks,
                    (response: any) => {
                        setOrders(prevOrders =>
                            prevOrders.map(order =>
                                order.id === id
                                    ? { ...order, [field]: value }
                                    : order
                            )
                        );
                        resolve();
                        setRefreshTrigger(prev => !prev);
                    },
                    (error: any) => {
                        toast.error(error.message || 'Failed to update remarks');
                        reject(error);
                    }
                );
            });
        } catch (error) {
            console.error('Error updating remarks:', error);
        }
        return { ...params.row, [field]: value };
    };
    const tripColumns: GridColDef[] = [
        { field: 'slNo', headerName: 'Sl.no', width: 60, headerAlign: 'center', align: 'center' },
        {
            field: 'startTime',
            headerName: 'Start Time',
            width: 120,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => formatDate(params.value)
        },
        { field: 'vehicleNumber', headerName: 'Vehicle Number', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'driver', headerName: 'Driver', width: 190, headerAlign: 'center', align: 'center' },
        { field: 'warehouse', headerName: 'Warehouse', width: 170, headerAlign: 'center', align: 'center' },
        { field: 'picked_delivered', headerName: 'Orders Picked/Delivered', width: 200, headerAlign: 'center', align: 'center' },
        {
            field: 'tripStatus',
            headerName: 'Trip Status',
            width: 220,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                let statusText = params.value;
                let additionalInfo = '';
                let statusColor = 'black';

                if (params.row.endTime) {
                    const endTime = new Date(params.row.endTime).toLocaleTimeString();
                    additionalInfo = ` at ${endTime}`;
                    statusColor = 'green';
                } else if (params.value === 'In Progress') {
                    statusColor = 'orange';
                } else if (params.value === 'Vehicle assigned') {
                    statusColor = 'blue';
                }

                return (
                    <Box display="flex" flexDirection="column" alignItems="center">
                        <Typography
                            sx={{
                                color: statusColor,
                                fontWeight: 'medium'
                            }}
                        >
                            {statusText}{additionalInfo}
                        </Typography>
                    </Box>
                );
            }
        },
        {
            field: 'remarks',
            headerName: 'Remarks',
            width: 200,
            headerAlign: 'center',
            align: 'center',
            editable: true,
            renderCell: (params) => (
                <Box
                    sx={{
                        width: '100%',
                        minHeight: '40px',
                        maxHeight: '100px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '6px',
                        backgroundColor: params.row.remarks ? '#f9f9f9' : '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        '&:hover': {
                            borderColor: '#68E0CF',
                            backgroundColor: '#f5f5f5'
                        }
                    }}
                >
                    <Typography
                        sx={{
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            lineHeight: '1.2',
                            width: '100%',
                            color: params.row.remarks ? 'inherit' : '#999',
                            fontStyle: params.row.remarks ? 'normal' : 'italic'
                        }}
                    >
                        {params.row.remarks || 'Click to add remarks...'}
                    </Typography>
                </Box>
            ),
            renderEditCell: (params) => (
                <Box
                    sx={{
                        width: '100%',
                        padding: '8px',
                    }}
                >
                    <TextField
                        multiline
                        fullWidth
                        variant="outlined"
                        value={params.value || ''}
                        onChange={(e) => params.api.setEditCellValue({
                            id: params.id,
                            field: params.field,
                            value: e.target.value
                        })}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                fontSize: '0.875rem',
                                '& textarea': {
                                    whiteSpace: 'pre-wrap',
                                    wordWrap: 'break-word',
                                    lineHeight: '1.5'
                                }
                            }
                        }}
                        autoFocus
                    />
                </Box>
            )
        }
    ];

    const updateField = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        if (!isNaN(Number(value))) {
            setPageSize(Number(value));
            setPage(0);
        }
    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (name === "fromDate") {
            setSelectedFromDate(value);
            const toDateInput = document.getElementById("toDate") as HTMLInputElement;
            if (toDateInput) {
                toDateInput.min = value;
            }
        }
        else if (name === "toDate") {
            if (new Date(value) >= new Date(selectedFromDate)) {
                setSelectedToDate(value);
            } else {
                toast.error("To date must be greater than or equal to From date");
            }
        }
    };

    return (
        <>
            <Header />
            <Box sx={{ marginTop: "70px" }}>
                <Heading
                    title="Orders"
                    closeIcon="false"
                    leftContent={
                        <>
                            {activeTab === 'Order Details' ? (
                                <Box display="flex" alignItems="center">
                                    <Typography style={{ marginRight: '5px' }}>Show Entries:</Typography>
                                    <Dropdown
                                        options={showEntries}
                                        selectedValue={pageSize.toString()}
                                        handleChange={(event) => updateField(event)}
                                        width="90px"
                                        height="50px"
                                    />
                                </Box>
                            ) : (
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Typography style={{ marginRight: '5px' }}>Show Entries:</Typography>
                                    <Dropdown
                                        options={showEntries}
                                        selectedValue={pageSize.toString()}
                                        handleChange={(event) => updateField(event)}
                                        width="90px"
                                        height="50px"
                                    />

                                    <DatePicker
                                        id="fromDate"
                                        name="fromDate"
                                        value={selectedFromDate}
                                        title="From"
                                        onChange={handleDateChange}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                    />
                                    <DatePicker
                                        id="toDate"
                                        name="toDate"
                                        value={selectedToDate}
                                        title="To"
                                        onChange={handleDateChange}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                    />
                                </Box>
                            )}
                        </>
                    }
                    rightContent={
                        <>
                            {activeTab === 'Order Details' ? (
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Dropdown
                                        options={warehouseOptions}
                                        selectedValue={selectedWarehouse?.id || ''}
                                        handleChange={(event) => handleWarehouseChange(event)}
                                        placeholder="Choose Warehouse"
                                        label={"Choose Warehouse"}
                                        width="190px"
                                        height="50px"
                                    />
                                    {userRole === 'client_company_admin' && (
                                        <>
                                            <Button
                                                variant="contained"
                                                className='custom-button'
                                                startIcon={<UploadIcon />}
                                                onClick={handleUploadClick}
                                                aria-controls="upload-menu"
                                                aria-haspopup="true"
                                            >
                                                Upload Orders
                                            </Button>
                                            <Menu
                                                id="upload-menu"
                                                anchorEl={uploadAnchorEl}
                                                keepMounted
                                                open={Boolean(uploadAnchorEl)}
                                                onClose={handleUploadClose}
                                            >
                                                <MenuItem onClick={() => {
                                                    handleUploadClose();
                                                    setSingleOrderModalOpen(true);
                                                }}>
                                                    Single Order
                                                </MenuItem>
                                                <MenuItem onClick={handleBulkOrdersClick}>
                                                    Bulk Orders
                                                </MenuItem>
                                            </Menu>
                                        </>
                                    )}
                                    <Button
                                        variant="contained"
                                        className='custom-button'
                                        onClick={() => {
                                            if (selectedRows.length === 0) {
                                                toast.error('Please select at least one order');
                                            } else {
                                                setAssignModalOpen(true);
                                            }
                                        }}
                                    >
                                        Assign Vehicle
                                    </Button>
                                </Box>
                            ) : (
                                <Box display="flex" alignItems="center" gap="10px">
                                    <Dropdown
                                        options={warehouseOptions}
                                        selectedValue={selectedWarehouse?.id || ''}
                                        handleChange={(event) => handleWarehouseChange(event)}
                                        placeholder="Choose Warehouse"
                                        label={"Choose Warehouse"}
                                        width="190px"
                                        height="50px"
                                    />
                                    <Dropdown
                                        options={vehicleOptions}
                                        selectedValue={selectedVehicle?.id || ''}
                                        handleChange={(event) => handleVehicleChange(event)}
                                        placeholder="Choose Vehicle"
                                        label={"Choose Vehicle"}
                                        width="190px"
                                        height="50px"
                                    />
                                </Box>
                            )}
                        </>
                    }
                />
                <Box sx={{ marginBottom: 2, marginLeft: { xs: '10px', sm: '180px' } }}>
                    <StatusFilterTabs
                        tabs={['Order Details', 'Trip Details']}
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                    />
                </Box>

                <Box
                    className="table-container custom-data-grid"
                
                >
                    {activeTab === 'Order Details' ? (
                        <DataGrid
                            rows={orderRows}
                            columns={orderColumns}
                            autoHeight={false}
                            disableRowSelectionOnClick
                            disableColumnResize
                            hideFooterPagination
                            checkboxSelection
                            onRowSelectionModelChange={(newSelection) => {
                                handleRowSelection(newSelection as number[]);
                            }}
                            rowSelectionModel={selectedRows}
                            processRowUpdate={handleOrderRemarksEdit}
                            onProcessRowUpdateError={(error) => console.error(error)}
                            editMode="cell"
                            sx={{
                                '& .MuiDataGrid-cell': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'normal !important',
                                    wordWrap: 'break-word',
                                    lineHeight: '1.5 !important',
                                    padding: '8px 16px',
                                },
                                '& .MuiDataGrid-row': {
                                    maxHeight: 'none !important',
                                    minHeight: '48px !important',
                                    '&.MuiDataGrid-row--editing': {
                                        boxShadow: 'none',
                                    },
                                },
                                '& .MuiDataGrid-cell--editing': {
                                    backgroundColor: 'transparent',
                                    padding: 0,
                                    '& .MuiOutlinedInput-root': {
                                        height: '100%',
                                        alignItems: 'flex-start',
                                    },
                                },
                                '& .MuiDataGrid-cell:focus': {
                                    outline: 'none',
                                },
                            }}
                            getRowHeight={() => 'auto'}
                        />
                    ) : (
                        <DataGrid
                            rows={tripRows}
                            columns={tripColumns}
                            autoHeight
                            disableRowSelectionOnClick
                            disableColumnResize
                            hideFooterPagination
                            processRowUpdate={handleTripRemarksEdit}
                            onProcessRowUpdateError={(error) => console.error(error)}
                            editMode="cell"
                            sx={{
                                '& .MuiDataGrid-cell': {
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'normal !important',
                                    wordWrap: 'break-word',
                                    lineHeight: '1.5 !important',
                                    padding: '8px 16px',
                                },
                                '& .MuiDataGrid-row': {
                                    maxHeight: 'none !important',
                                    minHeight: '48px !important',
                                    '&.MuiDataGrid-row--editing': {
                                        boxShadow: 'none',
                                    },
                                },
                                '& .MuiDataGrid-cell--editing': {
                                    backgroundColor: 'transparent',
                                    padding: 0,
                                    '& .MuiOutlinedInput-root': {
                                        height: '100%',
                                        alignItems: 'flex-start',
                                    },
                                },
                                '& .MuiDataGrid-cell:focus': {
                                    outline: 'none',
                                },
                            }}
                        />
                    )}
                </Box>
                <Box sx={{ marginLeft: '50%', marginTop: '8px' }}>
                    <Newpagination
                        rows={activeTab === 'Order Details' ? totalRecords : totalTripRecords}
                        pageSize={pageSize}
                        page={page}
                        handlePageChange={handlePageClick}
                    />
                </Box>
            </Box>

            <OrderDetailsModal
                open={orderDetailsModalOpen}
                onClose={() => setOrderDetailsModalOpen(false)}
                orderId={selectedOrderId}
                orders={orders}
                // paymentMode={orders.find(order => order.id === selectedOrderId)?.cod || '0'}
                // amountCash={orders.find(order => order.id === selectedOrderId)?.amount_cash || ''}
                // amountUPI={orders.find(order => order.id === selectedOrderId)?.amount_upi || 's'}
                // onRefresh={() => setRefreshTrigger(prev => !prev)}
            />

            {assignModalOpen && (
                <AssignVehicleModal
                    open={assignModalOpen}
                    onClose={() => setAssignModalOpen(false)}
                    selectedWarehouseName={selectedWarehouseName}
                    warehouseOptions={warehouseOptions}

                    vehicleOptions={vehicleOptions}
                    onAssign={handleAssignVehicle}
                    refreshData={refreshData}
                    selectedOrderIds={selectedRows}
                    selectedTripIds={selectedTripIds}
                    orders={orders}
                />

            )}
            <SingleOrderModal
                open={singleOrderModalOpen}
                onClose={() => setSingleOrderModalOpen(false)}
                onSubmit={handleCreateSingleOrder}
                step={step}
                setStep={setStep}
                deliveryType={deliveryType}
                setDeliveryType={setDeliveryType}
                items={items}
                setItems={setItems}
                currentItem={currentItem}
                setCurrentItem={setCurrentItem}
                showGst={showGst}
                setShowGst={setShowGst}
                weight={weight}
                setWeight={setWeight}
                crates={crates}
                setCrates={setCrates}
                cod={cod}
                setCod={setCod}
                logisticsCost={logisticsCost}
                setLogisticsCost={setLogisticsCost}
                grandTotal={grandTotal}
                setGrandTotal={setGrandTotal}
                dimensions={dimensions}
                setDimensions={setDimensions}
                formData={formData}
                setFormData={setFormData}
            />


            <BulkOrderModal
                showModal={bulkOrdersModalOpen}
                setShowModal={setBulkOrdersModalOpen}
                handleClose={() => {
                    setBulkOrdersModalOpen(false);
                    setSelectedFile(null);
                }}
                setUploadPreviewModal={setUploadPreviewModal}
                setSelectedFile={setSelectedFile}
                file={selectedFile}
                setTableData={setTableData}
                setTableColumns={setTableColumns}
            />
            <UploadPreviewModal
                isOpen={uploadPreviewModal}
                tableData={tableData}
                tableColumns={tableColumns}
                file={selectedFile}
                setFile={setSelectedFile}
                setUploadModal={setUploadPreviewModal}
                setTableData={setTableData}
                setTableColumns={setTableColumns}
                setShowModal={setBulkOrdersModalOpen}
            />
            <NavBar selected="Orders" />
        </>
    );
};

export default OrdersPage;